import { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { StyledTableSortingIndicator } from './TableSortingIndicator.style';
import {
	ITheme,
	IconChevronDropUp,
	IconChevronDropDown,
} from '@montel/montelpro-shared-components-v2';

export interface TableSortingButtonProps {
	order: 'asc' | 'desc';
}

const TableSortingIndicator: FunctionComponent<TableSortingButtonProps> = ({
	order,
}) => {
	const { colors } = useTheme() as ITheme;
	const arrowUpColor = order === 'asc' ? '#FFF' : colors.textSubtle;
	const arrowDownColor = order === 'desc' ? '#FFF' : colors.textSubtle;

	return (
		<StyledTableSortingIndicator>
			<IconChevronDropUp color={arrowUpColor} boxSize="8px" />
			<IconChevronDropDown color={arrowDownColor} boxSize="8px" />
		</StyledTableSortingIndicator>
	);
};

export default TableSortingIndicator;
